/* global gsap */

/**
 * Globe path animation
 * @param {Element} element - element to animate
 */
function globeAnimation(element) {
  gsap.to('#globe-path', {
    scrollTrigger: {
      trigger: element,
      start: '-150px 60%',
      end: '250px 20%',
      scrub: 1,
    },
    motionPath: {
      path: '#globe-main-line',
      align: '#globe-main-line',
      alignOrigin: [0.5, 0.5],
      autoRotate: true,
      start: 0.03,
      end: 0.95,
      type: 'cubic',
    },
    immediateRender: true,
    ease: 'power1.inOut',
    transformOrigin: '50% 50%',
    onUpdate: function() {
      if (this.progress() > .58) {
        circleChange();
      }
    },
  });

  const circleChange = () => {
    return gsap.to('#globe-circle', {
      fill: '#7CCCFF',
    });
  };
}

export {globeAnimation};
